import { RouteObject } from "react-router-dom";
import { PrivateRoutes, GuestRoutes } from "./routeGuards";
import AppLayout from "../layout/Layout";
import {
  ErrorPageView,
  HomeView,
  NotFoundView,
} from "./views";
import { LoginPage, RegisterPage } from "../../features/auth/routes";
import {
  AddTicketPage,
  BankPage,
  BanksPage,
  CarPage,
  CarsPage,
  CashBoxPage,
  CashBoxesPage,
  CustomerPage,
  CustomersPage,
  EditBankPage,
  EditCarPage,
  EditCashBoxPage,
  EditCustomerPage,
  EditIncomePage,
  EditItemPage,
  EditOutcomePage,
  EditSystemPage,
  EditWorkPage,
  EntriesPage,
  HistoryPage,
  IncomePage,
  ItemEntriesPage,
  IncomesPage,
  ItemPage,
  ItemsPage,
  OutcomePage,
  OutcomesPage,
  SystemPage,
  SystemsPage,
  TicketsPage,
  WorkPage,
  WorksPage,
} from "../../features/tickets/public";
import {
  AddDocumentPage,
  DocumentFieldsStructurePage,
  DocumentSettingsPage,
  DocumentsPage,
  EditDocumentPage,
} from "../../features/documents/routes";
import { AccountFieldsStructurePage } from "../../features/structures/routes";
import { TablesPage } from "../../features/tables/routes";
import { ReportsPage } from "../../features/reports/routes";
import { SettingsPage } from "../../features/settings/routes";
import { DebugHeadersPage } from "../../features/debug/routes";

const accountStructureRoutes = (segment: string): RouteObject[] => [
  {
    path: `/${segment}/structure/browse`,
    element: <AccountFieldsStructurePage />,
    errorElement: <ErrorPageView />,
  },
  {
    path: `/${segment}/structure/form`,
    element: <AccountFieldsStructurePage />,
    errorElement: <ErrorPageView />,
  },
];

export const routeConfig: RouteObject[] = [
  {
    path: "/debug-headers",
    element: <DebugHeadersPage />,
    errorElement: <ErrorPageView />,
  },
  {
    element: <GuestRoutes />,
    children: [
      {
        path: "/login",
        element: <LoginPage />,
        errorElement: <ErrorPageView />,
      },
      {
        path: "/register",
        element: <RegisterPage />,
        errorElement: <ErrorPageView />,
      },
    ],
  },
  {
    element: <PrivateRoutes />,
    children: [
      {
        path: "/",
        element: <AppLayout />,
        children: [
          {
            path: "/",
            element: <HomeView />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/",
            element: <TicketsPage />,
            children: [
              { path: "customers", element: <CustomersPage />, errorElement: <ErrorPageView /> },
              { path: "works", element: <WorksPage />, errorElement: <ErrorPageView /> },
              { path: "items", element: <ItemsPage />, errorElement: <ErrorPageView /> },
              { path: "cars", element: <CarsPage />, errorElement: <ErrorPageView /> },
              { path: "incomes", element: <IncomesPage />, errorElement: <ErrorPageView /> },
              { path: "outcomes", element: <OutcomesPage />, errorElement: <ErrorPageView /> },
              { path: "banks", element: <BanksPage />, errorElement: <ErrorPageView /> },
              { path: "cash-boxes", element: <CashBoxesPage />, errorElement: <ErrorPageView /> },
              { path: "system", element: <SystemsPage />, errorElement: <ErrorPageView /> },
            ],
          },

          ...accountStructureRoutes("customers"),
          ...accountStructureRoutes("items"),
          ...accountStructureRoutes("works"),
          ...accountStructureRoutes("cars"),
          ...accountStructureRoutes("incomes"),
          ...accountStructureRoutes("outcomes"),
          ...accountStructureRoutes("banks"),
          ...accountStructureRoutes("cash-boxes"),
          ...accountStructureRoutes("system"),

          {
            path: "/customers/add",
            element: <AddTicketPage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/customers/:id",
            element: <CustomerPage />,
            errorElement: <ErrorPageView />,
            children: [
              { path: "", element: <EditCustomerPage />, errorElement: <ErrorPageView /> },
              { path: "journal-entries", element: <EntriesPage />, errorElement: <ErrorPageView /> },
              { path: "history", element: <HistoryPage />, errorElement: <ErrorPageView /> },
            ],
          },
          {
            path: "/items/add",
            element: <AddTicketPage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/items/:id",
            element: <ItemPage />,
            children: [
              { path: "", element: <EditItemPage />, errorElement: <ErrorPageView /> },
              { path: "journal-entries", element: <ItemEntriesPage />, errorElement: <ErrorPageView /> },
              { path: "history", element: <HistoryPage />, errorElement: <ErrorPageView /> },
            ],
          },
          {
            path: "/works/add",
            element: <AddTicketPage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/works/:id",
            element: <WorkPage />,
            children: [
              { path: "", element: <EditWorkPage />, errorElement: <ErrorPageView /> },
              { path: "journal-entries", element: <EntriesPage />, errorElement: <ErrorPageView /> },
              { path: "history", element: <HistoryPage />, errorElement: <ErrorPageView /> },
            ],
          },
          {
            path: "/cars/add",
            element: <AddTicketPage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/cars/:id",
            element: <CarPage />,
            children: [
              { path: "", element: <EditCarPage />, errorElement: <ErrorPageView /> },
              { path: "journal-entries", element: <EntriesPage />, errorElement: <ErrorPageView /> },
              { path: "history", element: <HistoryPage />, errorElement: <ErrorPageView /> },
            ],
          },
          {
            path: "/incomes/add",
            element: <AddTicketPage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/incomes/:id",
            element: <IncomePage />,
            children: [
              { path: "", element: <EditIncomePage />, errorElement: <ErrorPageView /> },
              { path: "journal-entries", element: <EntriesPage />, errorElement: <ErrorPageView /> },
            ],
          },
          {
            path: "/outcomes/add",
            element: <AddTicketPage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/outcomes/:id",
            element: <OutcomePage />,
            children: [
              { path: "", element: <EditOutcomePage />, errorElement: <ErrorPageView /> },
              { path: "journal-entries", element: <EntriesPage />, errorElement: <ErrorPageView /> },
            ],
          },
          {
            path: "/banks/add",
            element: <AddTicketPage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/banks/:id",
            element: <BankPage />,
            children: [
              { path: "", element: <EditBankPage />, errorElement: <ErrorPageView /> },
              { path: "journal-entries", element: <EntriesPage />, errorElement: <ErrorPageView /> },
            ],
          },
          {
            path: "/cash-boxes/add",
            element: <AddTicketPage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/cash-boxes/:id",
            element: <CashBoxPage />,
            children: [
              { path: "", element: <EditCashBoxPage />, errorElement: <ErrorPageView /> },
              { path: "journal-entries", element: <EntriesPage />, errorElement: <ErrorPageView /> },
            ],
          },
          {
            path: "/system/add",
            element: <AddTicketPage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/system/:id",
            element: <SystemPage />,
            children: [
              { path: "", element: <EditSystemPage />, errorElement: <ErrorPageView /> },
              { path: "journal-entries", element: <EntriesPage />, errorElement: <ErrorPageView /> },
            ],
          },

          {
            path: "/documents",
            element: <DocumentsPage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/documents/structure/browse",
            element: <DocumentFieldsStructurePage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/documents/structure/account",
            element: <DocumentFieldsStructurePage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/documents/structure/car",
            element: <DocumentFieldsStructurePage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/documents/structure/item",
            element: <DocumentFieldsStructurePage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/documents/structure/work",
            element: <DocumentFieldsStructurePage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/documents/structure/document",
            element: <DocumentFieldsStructurePage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/documents/add",
            element: <AddDocumentPage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/documents/add/:documentSettingsId",
            element: <AddDocumentPage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/documents/:id",
            element: <EditDocumentPage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/documents/settings/:id",
            element: <DocumentSettingsPage />,
            errorElement: <ErrorPageView />,
          },

          {
            path: "/tables",
            element: <TablesPage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/structure",
            element: <DocumentFieldsStructurePage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/reports",
            element: <ReportsPage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "/settings",
            element: <SettingsPage />,
            errorElement: <ErrorPageView />,
          },
          {
            path: "*",
            element: <NotFoundView />,
          },
        ],
      },
    ],
  },
];
